import { cc, getMillisFromMinutes, RestaurantUtils } from "..";
export const OrderUtils = {
    getOrderManagementStatus(o, tz) {
        if (o.status !== "confirmed") {
            return o.status;
        }
        const due = this.dueInMillis(o, tz);
        if (due < getMillisFromMinutes(120)) {
            return "due_soon";
        }
        return "upcoming";
    },
    dueInMillis(o, tz) {
        if (o.ready_at) {
            return o.ready_at - Date.now();
        }
        if (o.config_due === "later") {
            return o.config_timestamp - Date.now();
        }
        return 0;
    },
    icon(service) {
        switch (service) {
            case "pickup":
                return "shopping-bag";
            case "delivery":
                return "motorcycle";
            case "dine_in":
                return "utensils";
            case "table_booking":
                return "calendar-alt";
            default:
                return "shopping-bag";
        }
    },
    sortByDue(tz) {
        return (a, b) => {
            console.log("dueSort");
            const dueA = this.dueInMillis(a, tz);
            const dueB = this.dueInMillis(b, tz);
            if (dueA < dueB) {
                return -1;
            }
            else if (dueA > dueB) {
                return 1;
            }
            return 0;
        };
    },
    sortByCreated(a, b) {
        // BIGGER VALUES LAST
        console.log("createdSort");
        if (a.created < b.created) {
            return -1;
        }
        else if (a.created > b.created) {
            return 1;
        }
        return 0;
    },
    sortByUpdated(a, b) {
        // BIGGER VALUES FIRST
        console.log("updatedSort");
        if (a.updated && b.updated) {
            if (a.updated > b.updated) {
                return -1;
            }
            else if (a.updated < b.updated) {
                return 1;
            }
            return 0;
        }
        return this.sortByCreated(a, b);
    },
    sortFunctionByStatus(s) {
        if (["unconfirmed"].indexOf(s) !== -1) {
            return this.sortByCreated;
        }
        else if (["complete", "cancelled"].indexOf(s) !== -1) {
            return this.sortByUpdated;
        }
        return this.sortByDue(cc.timezone);
    },
    checkBlockedAddresses(destination, block) {
        block = block || [];
        if (block.length > 0) {
            for (const a of block) {
                if (a !== "") {
                    if (destination.toLowerCase().indexOf(a.toLowerCase()) !== -1) {
                        return true;
                    }
                }
            }
        }
        return false;
    },
};
export function orderDishesSort(menus, dishes) {
    return dishes
        .slice()
        .sort((a, b) => {
        const aFind = RestaurantUtils.menu.findDish(menus, a.dish_id);
        const bFind = RestaurantUtils.menu.findDish(menus, b.dish_id);
        if (!aFind || !bFind)
            return 0;
        if (!aFind && bFind)
            return 1;
        if (aFind && !bFind)
            return -1;
        if (aFind.menu.position === bFind.menu.position) {
            if (aFind.category.position === bFind.category.position) {
                if (aFind.dish.position > bFind.dish.position)
                    return 1;
                if (aFind.dish.position < bFind.dish.position)
                    return -1;
                return 0;
            }
            else {
                if (aFind.category.position > bFind.category.position)
                    return 1;
                if (aFind.category.position < bFind.category.position)
                    return -1;
                return 0;
            }
        }
        else {
            if (aFind.menu.position > bFind.menu.position)
                return 1;
            if (aFind.menu.position < bFind.menu.position)
                return -1;
            return 0;
        }
    })
        .map((d, i) => {
        return Object.assign(Object.assign({}, d), { position: i });
    });
}
export * from "./origins";
//# sourceMappingURL=index.js.map